import React, {FormEvent, ReactNode, useEffect, useState} from 'react';
import {Form, Button, Row, Container, Col, Card, Stack} from 'react-bootstrap';
import {Navigate, useNavigate} from 'react-router-dom';
import {DI, Loading, Box, FirebaseService, AuthService, StorageService, UrlUtils} from "shared-lib";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {AuthConst} from "@consts";
import {User} from "firebase/auth";

const firebaseService: FirebaseService = DI.get(FirebaseService);
const authService: AuthService = DI.get(AuthService);
type Props = {};
type States = { inProgress: boolean, user: User, unVerified: boolean };

export const EmailVerificationPage: React.FunctionComponent<Props> = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const [states, setStates] = useState({inProgress: true, user: authService.getCurrentUser()} as States);

    useEffect(() => {
        if (states.user) {
            setStates({...states, inProgress: false, unVerified: true});
        } else {
            navigate('/', {replace: true});
        }
    }, []);


    const sendVerificationLink = () => {
        setStates({...states, inProgress: true});
        firebaseService.sendEmailVerification(
            states.user,
            UrlUtils.generateAbsoluteUrl(AuthConst.SIGN_IN_PAGE, {email: states.user.email})
        ).then(() => navigate(AuthConst.SIGN_UP_RESULT_PAGE, {replace: true}));
    }


    const renderByCases = () => {
        if (states.unVerified) {
            return (
                <Box className="login-page__form">
                    <Loading show={states.inProgress}/>
                    <Stack gap={2}>
                        <p>{t('emailVerification.unVerifiedMessage', {email: states.user.email})}</p>
                        <Button variant="primary" type="button" onClick={sendVerificationLink}
                                className="w-100 btn-lg">{t('emailVerification.sendAgain')}</Button>
                    </Stack>
                </Box>
            )
        } else {
            return <Loading show={states.inProgress}/>
        }
    }

    return (
        <Stack className="login-page min-vh-100 justify-content-center align-items-center bg-dark fn-loading-container">
            <img className="login-page__logo mb-4" src="./logo_440x64.png"/>
            {renderByCases()}
        </Stack>
    );
}
